import React from 'react'
//router
import {Redirect} from 'react-router-dom'
//store
import {observer} from 'mobx-react'
import userState from '../store/userState'
import events from '../store/events'
//plugin
import axios from 'axios';
//config
import config from '../config'
//assets
import '../assets/css/Login.css'
import logo from '../assets/img/cocorobo__logo.svg';

@observer
class Login extends React.Component {
  componentDidMount(){
    window.addEventListener('message',function(e){
      if(e.data.id == 'loginVerify'){
        if(e.data.status === 'logged'){
            userState.login = true;
        }
      }
    })
    userState.handleLogin();
  }
  render () {
    if(userState.login){
      return <Redirect to = '/iot/events' />
    }
    return(
      <div className='Login'>
        <div className="Login__title">
          <img
            src={logo}
            width='50%'
            alt='logo'
            style={{display:'block',margin:'0 auto'}}
            />
          <span>Coco Cloud</span>
        </div>
        <div className="Login__panel">
          <div className='Login__ifr'>
            <iframe
              id='Login__ifr'
              src={'//cocorobo.hk/login'}
              scrolling='no'
              width='300'
              height='800'
              target='_blank'
              style={{marginTop:'-300px',marginLeft:'0',border:'none'}}
              />
          </div>
        </div>
      </div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js